import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=SINGLE_QTV_EXP:control
// ?preferred_variant=SINGLE_QTV_EXP:variant_1
// ?preferred_variant=SINGLE_QTV_EXP:variant_2
// ?preferred_variant=SINGLE_QTV_EXP:variant_3
// ?preferred_variant=SINGLE_QTV_EXP:variant_4
// ?preferred_variant=SINGLE_QTV_EXP:variant_5

// ?remove_preferred_experiment=SINGLE_QTV_EXP

export const SingleQtvExpName = 'SINGLE_QTV_EXP' as const;

export type SingleQtvExpVariants = ToVariants<typeof SingleQtvExpVariants>;

export const SingleQtvExpVariants = {
	CONTROL: 'control',
	VARIANT_1: 'variant_1',
	VARIANT_2: 'variant_2',
	VARIANT_3: 'variant_3',
	VARIANT_4: 'variant_4',
	VARIANT_5: 'variant_5',
} as const;

export default generate(
	SingleQtvExpName,
	SingleQtvExpVariants,
	() => {
		return true;
	},
	async instance => {
		return !instance.$store.getters['user/isLoggedIn'];
	}
);
